// disable eslint rules for this file
/* eslint-disable global-require */
/* eslint-disable import/no-dynamic-require */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl, IntlProvider } from 'react-intl';
import { isMultilingual, getLocaleByPath } from 'getOpCoRoutes';
import Toast from '@Components/Toast';

class LanguageToast extends Component {
  constructor(props) {
    super(props);
    this.toast = React.createRef();
    const defaultLocale = isMultilingual()
      ? getLocaleByPath(props.match.path)
      : process.env.REACT_APP_DEFAULT_LANGUAGE;
    this.state = {
      locale: defaultLocale,
      messages: require(`../../../i18n/${process.env.REACT_APP_COUNTRY}/${defaultLocale}.json`),
    };
  }

  componentDidMount() {
    const langSwitcherLinks = document.querySelectorAll('.language-switcher .language-link');
    langSwitcherLinks.forEach((link) => {
      link.addEventListener('click', this.handleLanguageClick.bind(this));
    });
  }

  /**
   * Handle language switcher links click whenever the Language Switcher is on the page.
   * @param e
   */
  handleLanguageClick(e) {
    e.preventDefault();
    // Always update Proceed link
    const newLocale = e.target.getAttribute('hreflang');
    this.setState({
      locale: newLocale,
      messages: require(`../../../i18n/${process.env.REACT_APP_COUNTRY}/${newLocale}.json`),
    });
    this.setLinkToProceed(e.target.getAttribute('href'));
  }

  /**
   * Update Proceed link in the toast with the proper URL.
   *
   * @param {String} url
   *  URL from the clicked language link.
   */
  setLinkToProceed(url) {
    this.toast.current.querySelector('#toast-cta-continue')
      .setAttribute('href', url);
  }

  render() {
    const { locale, messages } = this.state;

    return (
      <IntlProvider locale={locale} messages={messages}>
        <Toast
          forwardRef={this.toast}
          message={<FormattedMessage id="Toast.LanguageSwitcher.Text" />}
          anchor="language-switch"
          withCTA
        />
      </IntlProvider>
    );
  }
}

export default injectIntl(withRouter(LanguageToast));
